
import Vue from "vue";
import { UserConfigService } from "@/services/user-config-service";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";
import { ReportService } from "@/services/report-service";
import { IReportEngineSettingsWrapper } from "../../utils/report-engine-settings/report-engine-settings-wrapper";
import { BrowseExtraButtonLocation } from "@/utils/browse/browse-extra-button";
import { ISelectItem } from "winfakt-vue-components";
import { CustomButton } from "@/utils/buttons/custom-button";
import { AuthService } from "@/services";
import AppCustomButtonModal from "@/components/browse/CustomButtonModal.vue";
import { processIframeUrl } from "@/utils/iframe";

export default Vue.extend({
	data(){
		return{
			reportsDropDownOpen: false,
			showCustomReportButtonModal: false,
			activeCustomReportButton: null as CustomButton | null
		};
	},
	props: {
		state: {
			type: Object as ()=>BrowseStateBase,
			required: true,
		},
		withPrintingButton: Boolean
	},
	computed: {
		isEnabled():boolean{
			if (this.state.dataSource.canMakeReports != undefined) {
				if (!this.state.dataSource.canMakeReports) {
					return false;
				}
			}
			return UserConfigService.hasCurrentUserPermission((p)=>p.CanMakeReports);
		},
		reportExtraButtons():ISelectItem<Function>[]{
			return this.state.extraButtons.filter(b=>b.Location == BrowseExtraButtonLocation.REPORTS).map(b=>b.toSelectItem(this.state));
		},
		customReportButtons(): CustomButton[] {
			return UserConfigService.getCustomReportButtonsForBrowse(this.state.browse.ID);
		},
		visibleCustomReportButtons(): CustomButton[] {
			return this.customReportButtons.filter(btn => {
				if (btn.AdminOnly && !AuthService.isDevModeEnabled) {
					return false;
				}
				return true;
			});
		}
	},
	methods: {
		openCustomReportModal() {
			this.reportsDropDownOpen = false;
			this.state.customReportsModalOpen = true;
		},
		printReport(settings:IReportEngineSettingsWrapper){
			this.reportsDropDownOpen = false;
			ReportService.openCreateReportModal(settings, settings.Settings.DefaultType);
		},
		openCustomReportButton(btn: CustomButton) {
			this.reportsDropDownOpen = false;
			if (btn.IntegrateInBrowse) {
				let url = processIframeUrl(btn.Url, {useElectronServerAsProxy: btn.UseDesktopAppAsProxy});
				let model = this.state.selectedItems.length > 0 ? this.state.selectedItems : null;
				if (model && model.length > 0) {
					const ids = model.map((item: any) => item.ID).join(",");
					url = url.replace("{id}", ids);
				}
				this.state.setInlineIframe(url, btn, model);
				return;
			}
			this.activeCustomReportButton = btn;
			this.showCustomReportButtonModal = true;
		},
	},
	components: {
		AppCustomButtonModal
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
